export default __webpack_public_path__ + "static/media/navbar-toggler-icon.2cea43ce.svg";